/**
 * This is a generic version of the extract. Hope it works.
 *
 * Given object var obj = {"key1":{"key2":{"key4":"1776"},"key3":"word"}},
 * - bsExtractFromObject(obj, "key1.key2.key4", "1999") => "1776"
 * - bsExtractFromObject(obj, "key1.key2.key9", "1999") => "1999"
 *
 * @param {*} object
 * @param {*} keyPath
 * @param {*} defaultValue
 * @returns
 */
function bsExtractFromObject(object, keyPath, defaultValue = null) {
  var keys = keyPath && keyPath.length ? keyPath.split('.') : [];
  var numKeys = keys.length;

  // Set null as default value if not defined.
  if (typeof defaultValue === 'undefined') {
    defaultValue = null;
  }

  for (var i = 0; i < numKeys; i++) {
    var key = keys[i];
    if (key !== null && object !== null && object.hasOwnProperty(key)) {
      object = object[key];
    } else {
      return defaultValue;
    }
  }

  return object;
}

export default {
  methods: {
    extractFromObject: function(object, keyPath, defaultValue = null) {
      return bsExtractFromObject(object, keyPath, defaultValue);
    },
    extract: function(keyPath, defaultValue = null) {
      return bsExtractFromObject(this, keyPath, defaultValue);
    }
  }
};
